import quickFetch from 'quick-fetch';
export const getEarlyRequestResult = (name, fallbackFetcher) => {
  const earlyRequest = name && quickFetch.getRequestStateByName(name);
  if (!earlyRequest) {
    if (!fallbackFetcher) {
      throw new Error('No fallback fetcher provided');
    }
    return fallbackFetcher();
  }
  return new Promise((resolve, reject) => {
    earlyRequest.whenFinished(result => {
      quickFetch.removeEarlyRequest(name);
      resolve(result);
    });
    earlyRequest.onError((__xhr, errorMessage) => {
      quickFetch.removeEarlyRequest(name);
      reject(new Error(errorMessage));
    });
  });
};